import data from '../../main/madontinh/madontinh.json';

const MADONTINH = {
    getTen(input) {
        input.forEach(p => {
            const resuit = data.filter(x => x.Ma === p.Ma && x.Id === p.Value && p.Ma !=='Th').map(j =>
                {if(j.Ten !== undefined) 
                   { p.Ten = j.Ten;}
                   else
                   {
                    p.Ten = p.Value;
                   }
                }
            );
            if (resuit.length === 0 || resuit === undefined)
            {
                p.Ten = p.Value;
            }

            if (p.Ma ==='Th')
            {
                
                let index = input.indexOf(p);
                if(index !== -1)
                {
                    input.splice(index,1);
                }
            }

        });
        data.filter(x=> x.Ma==='Th').map(j=>
            {
                let rs = {"Ma": j.Ma,
                "Value": j.Id,
                "Ten": j.Ten};
                input.push(rs);
            })
        return input;
    }
}

export default MADONTINH;